module.exports = __webpack_public_path__ + "img/share.42223889.png";